import { IMaskInput } from 'react-imask';
import { Input, useBoolean } from '@chakra-ui/react';

import { masks } from './model/masks';

const PhoneMaskedInput = ({ inputRef, value, activeMask, onChange, handleClear, ...props }) => {
  const [isFocused, setIsFocused] = useBoolean(false);
  const showMask = isFocused || value;
  console.log(value);

  return (
    <Input
      as={IMaskInput}
      ref={inputRef}
      value={value}
      unmask={true}
      mask={masks[activeMask].mask}
      // @ts-ignore
      lazy={!showMask}
      pl="16px"
      h="calc(100% - 3px)"
      fontSize={{ mobile: '16px', laptop: '18px' }}
      border="none"
      cursor="pointer"
      focusBorderColor="white"
      _hover={{ border: 'none' }}
      inputMode="tel"
      // На Android маска не блокирует нечисловые символы — перехватываем до IMask и запрещаем вводить что-то кроме цифр
      onBeforeInput={e => e.data && /[^\d]/.test(e.data) && e.preventDefault()}
      onFocus={setIsFocused.on}
      onBlur={() => {
        setIsFocused.off();
        if (['+7', '+375'].includes(value)) handleClear();
      }}
      onAccept={value => {
        if (['+7', '+375'].includes(value)) {
          handleClear();
          return;
        }
        // Был баг на Android смартфонах: маска не блокировала нечисловые символы, поэтому добавлена ручная проверка
        if (!/^\+?\d*$/.test(value)) return;
        onChange(value);
      }}
      {...props}
    />
  );
};

export default PhoneMaskedInput;
